
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 15.386c.44 0 .81-.37.81-.8V4.056l-.062-1.539.688.728 1.558 1.661a.749.749 0 00.554.246c.42 0 .748-.307.748-.728 0-.215-.092-.38-.246-.533L10.584.548C10.38.343 10.206.271 10 .271c-.215 0-.39.072-.595.277L5.94 3.891c-.153.154-.246.318-.246.533 0 .42.308.728.739.728a.77.77 0 00.564-.246l1.558-1.66.687-.729-.061 1.538v10.53c0 .432.38.8.82.8zm-5.886 8.029h11.762c2.143 0 3.22-1.067 3.22-3.18V10.003c0-2.112-1.077-3.178-3.22-3.178h-2.861v1.65h2.83c1.015 0 1.6.554 1.6 1.62v10.05c0 1.066-.585 1.62-1.6 1.62H4.135c-1.026 0-1.59-.554-1.59-1.62v-10.05c0-1.066.564-1.62 1.59-1.62h2.84v-1.65h-2.86c-2.144 0-3.22 1.066-3.22 3.178v10.234c0 2.112 1.076 3.179 3.22 3.179z","fill":"#2E7CF6"}})])
          )
        }
      }
    